
import { SWRConfiguration, SWRResponse } from "swr";

import { GetInstitutionSourceDataFindings, GetSourceDataFindingsResponse, UpdatedSourceDataFindingEvent } from "@/api/dtos";
import { AppSettings } from "@/AppSettings";
import useGet from "@/hooks/api/useGet";
import { HubConnection } from "@microsoft/signalr/dist/esm";
import { useCallback, useMemo } from "react";
import useSignalROnMessage from "../api/useSignalROnMessage";

const getData = (response?: SWRResponse<GetSourceDataFindingsResponse, GetSourceDataFindingsResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetSourceDataFindingsResponse, GetSourceDataFindingsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (response?: SWRResponse<GetSourceDataFindingsResponse, GetSourceDataFindingsResponse>) => ({});

export const useInstitutionSourceDataFindings = (institutionId?: number, configuration?: SWRConfiguration | undefined) => {
    const request = useMemo(() => {
        if (!institutionId) {
            return undefined;
        }

        return () => {
            return new GetInstitutionSourceDataFindings({ institutionId });
        }
    }, [institutionId]);

    const output = useGet(request, { getData, getError, getAdditionalState }, configuration);

    const onMessage = useCallback(async (connection: HubConnection, data: UpdatedSourceDataFindingEvent) => {
        if (
            institutionId === data.institutionId
        )
        {
            await output.refresh();
        }

    }, [
        output.refresh, 
        institutionId
    ]);

    useSignalROnMessage(AppSettings.channels.finding, onMessage);

    return output;
}

export default useInstitutionSourceDataFindings;